import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7225d981"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护车辆仓库信息")], -1));
const _hoisted_3 = {
  style: {
    "height": "400px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _component_WarehouseMap = _resolveComponent("WarehouseMap");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}车辆仓库`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "仓库名称",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.name = $event),
          placeholder: "请输入仓库名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "所属区域",
        prop: "areaId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.formModel.areaId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.areaId = $event),
          placeholder: "请选择区域信息",
          style: {
            "width": "100%"
          },
          props: $data.areaProps,
          options: $data.areas,
          onChange: $options.getWarehousePersonList
        }, null, 8, ["modelValue", "props", "options", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "经度",
            prop: "longitude"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.longitude,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.longitude = $event),
              placeholder: " 经度",
              disabled: true
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "纬度",
            prop: "latitude"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.latitude,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.latitude = $event),
              placeholder: " 纬度",
              disabled: true
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = $event => $options.getMap())
          }, {
            default: _withCtx(() => [_createTextVNode("定位")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "管理员",
        prop: "administratorName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.formModel.administratorId,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.administratorId = $event),
          multiple: "",
          placeholder: "请选择",
          onChange: $options.selectAdministrators,
          onClear: $options.clearData
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.storemanList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.userName,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange", "onClear"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "管理员联系电话"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.administratorMobile,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.administratorMobile = $event),
          disabled: true
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "仓库详细地址"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "textarea",
          modelValue: $data.formModel.address,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.address = $event),
          disabled: true
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['carWarehouse_add', 'carWarehouse_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: "地图定位",
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.dialogVisible = $event),
    width: "50%",
    center: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_WarehouseMap, {
      addressData: $data.address,
      type: $data.type,
      parkType: $data.parkType,
      onTransfer: $options.getAddressData,
      onClose: $options.closeMap
    }, null, 8, ["addressData", "type", "parkType", "onTransfer", "onClose"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}